import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { ScreenContextType } from 'navigation/wrapper/screen/ScreenWrapper';

export const LogoAndReturnOnlyScreenWrapper = () => {
  const { setScreenVariant } = useOutletContext<ScreenContextType>();

  useEffect(() => {
    setScreenVariant('LogoAndReturnOnly', 'None');
  }, []);

  return <Outlet />;
};
